import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App'
import AgentPage from './pages/AgentPage'
import EmailTemplatesPage from './pages/EmailTemplatesPage'
import EmailComposerPage from './pages/EmailComposerPage'
import EmailTrackerPage from './pages/EmailTrackerPage'
import SettingsPage from './pages/SettingsPage'
import './styles/index.css'

// Initialize Office.js
Office.onReady(() => {
  const root = ReactDOM.createRoot(document.getElementById('root')!)

  root.render(
    <React.StrictMode>
      <BrowserRouter basename="/outlook">
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/agent" element={<AgentPage />} />
          <Route path="/email-templates" element={<EmailTemplatesPage />} />
          <Route path="/email-composer" element={<EmailComposerPage />} />
          <Route path="/email-tracker" element={<EmailTrackerPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Routes>
      </BrowserRouter>
    </React.StrictMode>
  )
})